
import Scan from "../../../assets/outline/Scan.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ScanIcon({ className, dataTestid = "ScanIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Scan data-testid={dataTestid} className={classes} {...rest} />
  );
}
